export default {"src":"/_next/static/media/bell.459bb8e9.svg","height":27,"width":26,"blurWidth":0,"blurHeight":0};